import { combineReducers } from 'redux';
import alertReducer from "./alert.reducer";
import sidenavReducer from "./sidenav.reducer";
import userReducer from "./user.reducer";
import factoryReducer from "./factory.reducer";
import studyBrowserReducer from "./study-browser.reducer";
import preStudyReducer from "./pre-study.reducer";
import shiftReducer from "./shift.reducer";
import ieDistributionReducer from "./ie-distribution.reducer";

const rootReducer = combineReducers({
    alert: alertReducer,
    sidenav: sidenavReducer,
    users: userReducer,
    factories: factoryReducer,
    studyBrowser: studyBrowserReducer,
    preStudy: preStudyReducer,
    shifts: shiftReducer,
    ieDistributions: ieDistributionReducer
});

export default rootReducer;
